import DateFnsUtils from "@date-io/date-fns";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormLabel,
  Grid,
  Icon,
  IconButton,
  MenuItem,
  Paper,
  Popover,
  Select,
  Snackbar,
  Tab,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
  useMediaQuery
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import {
  ArrowDropDown,
  ArrowRight,
  CheckCircleOutline,
  Menu,
  People,
  PlayArrow,
  Search,
  SyncAltRounded,
} from "@material-ui/icons";
import { Alert, Autocomplete, Skeleton } from "@material-ui/lab";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { format, isValid } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import React, { Fragment, useEffect, useState } from "react";
import InputMask from "react-input-mask";
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import PaginationService from "../../Components/PaginationService";
import { AgendamentoDiario } from "../../interfaces/agendamento";
import { getAgendamentosDiarios } from "../../services/agendamentoOrganico";
import { getChamarSenha, getProximoAgendamento } from "../../services/atendimento";
import { getCheckPriority, getUnidadeServices } from "../../services/servicos";
import { healthCheck } from "../../services/websocket";
import { cpfMask } from "../../utils/cpfFormat";
import dateFormat, { extractDateFormat, extractHourFormat } from "../../utils/dateFormat";
import {
  AttendanceDialog,
  AttendanceDialogCancel,
  DependentsDialog,
} from "./components";
import AttendanceDialogStop from "./components/AttendanceDialogCancelStop";
import { StyledTableCell, StyledTableRow, useStyles } from "./style";
import { useAuth } from "../../contexts/auth";

type PriorityType = 'Prioritario' | 'Normal' | 'Ambos' | '';

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function OrganicSchedules(): JSX.Element {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const [value, setValue] = useState(0);
  const [loadingCurrentNext, setLoadingCurrentNext] = useState<boolean>(false);
  const [loadingPrevious, setloadingPrevious] = useState<boolean>(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [priorityType, setPriorityType] = useState<PriorityType>('');
  const { currentTicketOffice } = useAuth();
  const [currentSchedule, setCurrentSchedule] = useState<
    undefined | AgendamentoDiario
  >();

  const [nextSchedules, setNextSchedules] = useState<
    undefined | AgendamentoDiario[]
  >();
  const [previousSchedules, setPreviousSchedules] = useState<
    undefined | AgendamentoDiario[]
  >();

  const [countPagePreviousAttendance, setCountPagePreviousAttendance] =
    useState<number>(1);
  const [nextPagePreviousAttendance, setNextPagePreviousAttendance] =
    useState<number>(1);
  const [previousPagePreviousAttendance, setPreviousPagePreviousAttendance] =
    useState<number>(1);
  const [currentPagePreviousAttendance, setCurrentPagePreviousAttendance] =
    useState<number>(1);
  const [totalPagesPreviousAttendance, setTotalPagesPreviousAttendance] =
    useState<number>(1);
  const [schedulesDependentCurrent, setSchedulesDependentCurrent] = useState<
    undefined | AgendamentoDiario
  >();
  const [isDisabled, setIsDisabled] = useState(false);
  const [prioridadeOptions, setPrioridadeOptions] = useState(null);
  const [filter, setFilter] = useState<undefined | "CPF" | "Data">(undefined);
  const [valueFilter, setValueFilter] = useState<undefined | string>();
  const [showDetails, setShowDetails] = useState<undefined | string>();
  const [selectedDate, handleDateChange] = useState<undefined | Date>(
    new Date()
  );
  const normalPriorityId = prioridadeOptions
    ?.reduce((menor, atual) => (atual.peso < menor.peso ? atual : menor)).id;

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const disableNextButton = () => {
    setIsDisabled(true);
    setTimeout(() => {
      setIsDisabled(false);
    }, 10000);
  }

  async function fetchUnitAndToken() {
    const token = localStorage.getItem("gov_access_token_sso");
    const unidade = JSON.parse(localStorage.getItem("gov_ticket_office") || "");

    if (!getUnidadeServices) {
      throw new Error("Unidade inválida ou não definida.");
    }

    const slug_unidade = currentTicketOffice?.unidade?.slug_unidade || currentTicketOffice?.setor?.unidade?.slug_unidade;

    return { token, unidade, slug_unidade };
  }

  const fetchPriorityOptions = async () => {
    const { token } = await fetchUnitAndToken();

    await getCheckPriority(token)
      .then((response) => {
        setPrioridadeOptions(response.data);
      })
      .catch((error) => {
        console.error('Erro ao buscar prioridades:', error);
      });
  }

  async function fetchExistingscheduling() {
    try {
      const { token, unidade, slug_unidade } = await fetchUnitAndToken();

      setLoadingCurrentNext(true);

      const { data } = await getProximoAgendamento(token, {
        unidade: slug_unidade,
        ...(priorityType === 'Normal' && {
          prioridade_atendimento: null
        }),
        ...(priorityType === 'Prioritario' && {
          prioridade_atendimento_exceto: normalPriorityId
        }),
        guiche_id: unidade
      });

      if (data?.id) {
        setCurrentSchedule(data);
      }
    } catch (error: any) {
      setErrorMessage(error.message || 'Ocorreu um erro inesperado');
      setOpenSnackbar(true);
    } finally {
      setLoadingCurrentNext(false);
    }
  }

  async function agendamentosDaVez() {
    try {
      const { token, unidade, slug_unidade } = await fetchUnitAndToken();

      disableNextButton();
      setLoadingCurrentNext(true);

      const { data } = await getProximoAgendamento(token, {
        unidade: slug_unidade,
        ...(priorityType === 'Normal' && {
          prioridade_atendimento: null
        }),
        ...(priorityType === 'Prioritario' && {
          prioridade_atendimento_exceto: normalPriorityId
        }),
        ...(currentSchedule && unidade ? { guiche_id: unidade } : {}),
      });

      const isHealthy = await healthCheck();
      if (!isHealthy) {
        toast.error('Servidor indisponível');
        return;
      }

      if (data?.message) {
        toast.error(`${data.message || 'Não há atendimentos disponíveis'}`);
        return;
      }

      if (data?.id) {
        const { data: dataSenha } = await getChamarSenha(
          token,
          data.id,
          {
            guiche_id: unidade,
            tipo_agendamento: 'Diario',
          });

        setCurrentSchedule(data);
        toast.success(dataSenha?.message, { autoClose: 3000 });
      } else if (data?.message) {
        toast.error(`${data.message || 'Não há atendimentos disponíveis'}`);
      }
    } catch (error: any) {
      setErrorMessage(error.message || 'Ocorreu um erro inesperado');
      setOpenSnackbar(true);
    } finally {
      setLoadingCurrentNext(false);
    }
  }

  async function agendamentosHoje(page = 1) {
    try {
      const { token } = await fetchUnitAndToken();
      const guiche_id = JSON.parse(localStorage.getItem("gov_ticket_office") || "");

      setLoadingCurrentNext(true);
      const { data } = await getAgendamentosDiarios(token, { hoje: true, page, guiche_id, status: 'Em Atendimento' });
      if (data.results.length) {
        setCurrentSchedule(data.results[0]);
      } else {
        setCurrentSchedule(undefined);
        setNextSchedules(undefined);
      }
    } catch (error) {
    } finally {
      setLoadingCurrentNext(false);
    }
  }

  async function agendamentosAnteriores(page = 1) {
    try {
      const { token } = await fetchUnitAndToken();
      const guiche_id = JSON.parse(localStorage.getItem("gov_ticket_office") || "");

      setloadingPrevious(true);
      let params: any = {
        anteriores: true,
        page,
        guiche_id,
        out_status: 'Aguardando,Em Atendimento,Compareceu'
      };

      if (filter === "Data" && selectedDate) {
        params["data"] = format(selectedDate, "yyyy-MM-dd");
      }

      if (filter === "CPF") {
        params["cpf"] = valueFilter.replaceAll(/[^\w\s]/gi, "");
      }
      const { data } = await getAgendamentosDiarios(token, params);
      setCountPagePreviousAttendance(data.count);
      setNextPagePreviousAttendance(data.next);
      setPreviousPagePreviousAttendance(data.previous);
      setCurrentPagePreviousAttendance(data.current);
      setTotalPagesPreviousAttendance(data.total_pages);
      if (data.results.length) {
        const previousSchedulesLines = data.results;
        setPreviousSchedules(previousSchedulesLines);
      }
    } catch (error) {
    } finally {
      setloadingPrevious(false);
    }
  }

  useEffect(() => {
    const storedPriorityType = localStorage.getItem('selectedPriorityType');

    if (storedPriorityType) {
      setPriorityType(storedPriorityType as PriorityType);
    }

    fetchPriorityOptions()
    agendamentosAnteriores();
    agendamentosHoje()
    if (!currentSchedule) {
      fetchExistingscheduling()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [openAttendanceCancel, setOpenAttendanceCancel] =
    useState<boolean>(false);

  const [openAttendanceDialog, setOpenAttendanceDialog] =
    useState<boolean>(false);

  const [openDependentsDialog, setOpenDependentsDialog] =
    useState<boolean>(false);

  const [openAttendanceStop, setOpenAttendanceStop] = useState<boolean>(false);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index: number) => {
    setValue(index);
    handleCloseMenu();
  };
  const matchesMobile = useMediaQuery("(min-width:576px)");
  const [anchorElMenu, setAnchorElMenu] =
    React.useState<HTMLButtonElement | null>(null);

  const handleCloseMenu = () => {
    setAnchorElMenu(null);
  };

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    type?: "menu"
  ) => {
    if (type === "menu") {
      setAnchorElMenu(event.currentTarget);
    }
  };
  const searchUSer = () => {
    agendamentosAnteriores();
  };

  const changeAutoComplete = (event: any, valueParam: any): void => {

    if (valueParam === null) {
      history.go(0);
    }

    setFilter(valueParam);
  };

  const handleTipoAtendimentoChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedType = event.target.value as PriorityType;

    let message = '';
    if (selectedType === 'Prioritario') {
      message = "Tipo de Atendimento alterado com sucesso para Prioritário";
    } else if (selectedType === 'Normal') {
      message = "Tipo de Atendimento alterado com sucesso para Normal";
    } else if (selectedType === 'Ambos') {
      message = "Tipo de Atendimento alterado com sucesso para Ambos (Prioritário e Normal)";
    }

    localStorage.setItem('selectedPriorityType', selectedType);

    toast.info(message, { autoClose: 2000 });
    setPriorityType(selectedType);
  };

  return (
    <Box className={classes.main}>
      <Grid container spacing={2} className={classes.gridContainer}>
        <Grid item xs={12} sm={8} md={9} className={classes.gridItem}>
          <Box className={classes.boxContainer}>
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label-priority" className={classes.formLabel}>
                Tipo de Atendimento
              </FormLabel>
            </FormControl>
            <FormControl variant="outlined" className={classes.formControl}>
              <Select
                value={priorityType || ''}
                displayEmpty
                onChange={handleTipoAtendimentoChange}
                className={classes.selectInput}
                disabled={!!currentSchedule}
              >
                <MenuItem value="" disabled>
                  Selecione
                </MenuItem>
                <MenuItem value="Prioritario">Prioritário</MenuItem>
                <MenuItem value="Normal">Normal</MenuItem>
                <MenuItem value="Ambos">Ambos (Prioritário e Normal)</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Grid>

        <Grid item xs={12} sm={4} md={2}>
          <Button
            variant="contained"
            color="secondary"
            disabled={
              loadingCurrentNext ||
              currentSchedule?.status === 'Em Atendimento' ||
              isDisabled
            }
            className={classes.buttonNext}
            onClick={agendamentosDaVez}
            fullWidth
          >
            {!currentSchedule ? 'Chamar Próximo' : 'Chamar NOVAMENTE'}
          </Button>
        </Grid>
      </Grid>
      <Box
        style={{
          overflow: "auto",
        }}
      >
        <Paper className={classes.root}>
          <Box className={classes.tableDatail}>Atendimento da Vez</Box>
          <Box style={{ overflow: "auto" }}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow style={{ backgroundColor: '#F7F8FC', maxHeight: '44px' }}>
                  <StyledTableCell className={classes.tableHeader}>CIDADÃO</StyledTableCell>
                  <StyledTableCell className={classes.tableHeader} align="left">CPF</StyledTableCell>
                  <StyledTableCell className={classes.tableHeader} align="left">DATA/HORA</StyledTableCell>
                  <StyledTableCell className={classes.tableHeader} width={190} align="left">STATUS</StyledTableCell>
                  <StyledTableCell className={classes.tableHeader} align="left">SENHA</StyledTableCell>
                  <StyledTableCell className={classes.tableHeader} align="left">SERVIÇO</StyledTableCell>
                  <StyledTableCell className={classes.tableHeader} align="left">AÇÕES</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>

                {loadingCurrentNext ? (
                  <>
                    <TableRow>
                      <StyledTableCell >
                        <Box style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
                          <Button>
                            <ArrowDropDown />
                          </Button>
                          <Skeleton variant="text" width={100} />
                        </Box>
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <Skeleton variant="text" width={100} />
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <Skeleton variant="text" width={170} />
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <Skeleton variant="text" width={100} />
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <Skeleton variant="text" width={60} />
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <Skeleton variant="text" width={150} />
                      </StyledTableCell>
                      <StyledTableCell align="left" >
                        <Box style={{ display: 'flex', flexDirection: 'row', height: '100%', gap: '5px' }}>
                          <Skeleton variant="rect" width={44} height={40} />
                          <Skeleton variant="rect" width={44} height={40} />
                          <Skeleton variant="rect" width={44} height={40} />
                        </Box>
                      </StyledTableCell>
                    </TableRow>
                  </>
                ) : currentSchedule ? (
                  <Fragment key={currentSchedule.cpf}>
                    <StyledTableRow style={{ backgroundColor: "#FFF", color: '#000' }}>
                      <StyledTableCell component="th" scope="row">
                        {showDetails && showDetails === currentSchedule.ticket ? (
                          <Button onClick={() => setShowDetails(undefined)}>
                            <ArrowDropDown />
                          </Button>
                        ) : (
                          <Button
                            onClick={() => setShowDetails(currentSchedule.ticket)}
                          >
                            <ArrowRight />
                          </Button>
                        )}
                        {currentSchedule?.user?.first_name || currentSchedule?.nome || ''}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {cpfMask(currentSchedule.cpf)}
                      </StyledTableCell>
                      <StyledTableCell align="left" width={170}>
                        {`${dateFormat(currentSchedule.data)} ${currentSchedule.hora}`}
                      </StyledTableCell>
                      <StyledTableCell className={classes.status} width={170} align="left">
                        {currentSchedule.status}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {currentSchedule.senha_formatada}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {currentSchedule.servico.titulo}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {currentSchedule.para_dependente &&
                          currentSchedule.dependentes ? (
                          <Button
                            variant="contained"
                            size="small"
                            color="primary"
                            className={classes.buttonIcon}
                            onClick={() => {
                              setSchedulesDependentCurrent(currentSchedule);
                              setOpenDependentsDialog(true);
                            }}
                            title="Dependentes"
                          >
                            <People />
                          </Button>
                        ) : (
                          <span title="Sem dependentes">
                            <Button
                              variant="contained"
                              size="small"
                              color="primary"
                              className={classes.buttonIcon}
                              disabled
                            >
                              <People />
                            </Button>
                          </span>
                        )}
                        {(currentSchedule.status === "Aguardando Atendimento" ||
                          currentSchedule.status === "Compareceu") && (
                            <>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className={classes.buttonIcon}
                                onClick={() => setOpenAttendanceDialog(true)}
                                title="Iniciar atendimento"
                              >
                                <PlayArrow />
                              </Button>
                              <Button
                                variant="contained"
                                size="small"
                                className={classes.buttonIconAttention}
                                onClick={() => setOpenAttendanceCancel(true)}
                                title="Não compareceu"
                              >
                                <Icon className="material-icons-outlined">
                                  person_off
                                </Icon>
                              </Button>
                            </>
                          )}
                        {currentSchedule.status === "Em Atendimento" && (
                          <Button
                            variant="contained"
                            size="small"
                            color="primary"
                            className={classes.buttonIcon}
                            onClick={() => setOpenAttendanceStop(true)}
                            title="Finalizar atendimento"
                          >
                            <CheckCircleOutline />
                          </Button>
                        )}
                      </StyledTableCell>
                    </StyledTableRow>
                    {showDetails && showDetails === currentSchedule.ticket && (
                      <StyledTableRow
                        key={currentSchedule.ticket}
                        style={{
                          borderTopStyle: "dotted",
                          borderTopWidth: 1.4,
                        }}
                      >
                        <StyledTableCell colSpan={2}>
                          <Typography
                            className={classes.textTitleDetails}
                            style={{ paddingLeft: 60 }}
                          >
                            INICIO DO ATENDIMENTO
                          </Typography>
                          <Typography
                            className={classes.textValueDetails}
                            style={{ paddingLeft: 60 }}
                          >
                            {currentSchedule.status === "Não Compareceu"
                              ? "Não Compareceu"
                              : `${currentSchedule.hora_inicio
                                ? `${extractDateFormat(
                                  currentSchedule.hora_inicio
                                )} às ${extractHourFormat(
                                  currentSchedule.hora_inicio
                                )}`
                                : "Não iniciado"
                              }`}
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell colSpan={2}>
                          <Typography className={classes.textTitleDetails}>
                            PROTOCOLO AGENDAMENTO
                          </Typography>
                          <Typography className={classes.textValueDetails}>
                            {currentSchedule?.protocolo || ""}
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell colSpan={3}>
                          <Typography className={classes.textTitleDetails}>
                            PROTOCOLO ATENDIMENTO
                          </Typography>
                          <Typography className={classes.textValueDetails}>
                            {currentSchedule?.protocolo_atendimento ||
                              "Sem protocolo de atendimento"}
                          </Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </Fragment>
                ) : (
                  <Box height={77} />
                )}
              </TableBody>
            </Table>
          </Box>

          <DependentsDialog
            setOpenDependentsDialog={setOpenDependentsDialog}
            openDependentsDialog={openDependentsDialog}
            schedule={schedulesDependentCurrent}
          />
          <AttendanceDialog
            setOpenAttendanceDialog={setOpenAttendanceDialog}
            openAttendanceDialog={openAttendanceDialog}
            schedule={currentSchedule}
          />
          <AttendanceDialogCancel
            setOpenAttendanceCancel={setOpenAttendanceCancel}
            openAttendanceCancel={openAttendanceCancel}
            schedule={currentSchedule}
          />
          <AttendanceDialogStop
            setOpenAttendanceStop={setOpenAttendanceStop}
            openAttendanceStop={openAttendanceStop}
            schedule={currentSchedule}
          />
        </Paper>
      </Box>
      <Typography className={classes.textSchedules}>
        Lista de Atendimentos
      </Typography>

      <Box
        style={{
          overflow: "auto",
          background: "#FFF",
        }}
      >
        {matchesMobile ? (
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            aria-label="full width tabs example"
            style={{
              borderBottom: "1px solid #F7F8FC",
              borderRadius: 4,
              marginLeft: 24,
            }}
          >
            <Tab
              style={{ padding: 0 }}
              label={
                <span className={classes.tabLabel}>
                  Atendimentos Anteriores (
                  {previousSchedules ? previousSchedules.length : 0})
                </span>
              }
              {...a11yProps(1)}
            />
          </Tabs>
        ) : (
          <>
            <IconButton onClick={(e): void => handleClick(e, "menu")}>
              <Menu />
            </IconButton>
            {value === 0 &&
              `Atendimentos Anteriores (${countPagePreviousAttendance || 0})`}
            <Popover
              open={Boolean(anchorElMenu)}
              anchorEl={anchorElMenu}
              onClose={handleCloseMenu}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <Box>
                <Divider />
                <Divider />
                <MenuItem
                  className={classes.menuItem}
                  onClick={() => handleChangeIndex(0)}
                >
                  <Typography className={classes.textMenuItem}>
                    Atendimentos Anteriores ({countPagePreviousAttendance || 0})
                  </Typography>
                </MenuItem>
              </Box>
            </Popover>
          </>
        )}

        <Box>
          <TabPanel value={value} index={0} dir={theme.direction}>
            <Box
              display="flex"
              alignItems="center"
              flexWrap="wrap"
              style={{ width: "100%" }}
            >
              <Autocomplete
                id="controllable-states-demo"
                options={["Data", "CPF"]}
                value={filter}
                onChange={changeAutoComplete}
                style={{
                  width: !matchesMobile ? "100%" : 162,
                  marginBottom: 15,
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Filtrar por"
                  />
                )}
              />
              {matchesMobile && (
                <IconButton>
                  <SyncAltRounded />
                </IconButton>
              )}
              {filter && filter === "Data" && (
                <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableFuture={false}
                    invalidDateMessage="A data informada é inválida"
                    InputProps={{
                      className: classes.menuItem,
                      classes: { adornedEnd: classes.adornedEnd },
                    }}
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label="Selecione o dia"
                    format="dd/MM/yyyy"
                    value={selectedDate}
                    InputAdornmentProps={{ position: "end", color: "#000" }}
                    onChange={(date) => {
                      if (date && isValid(date)) {
                        handleDateChange(date);
                      }
                    }}
                  />
                </MuiPickersUtilsProvider>
              )}

              {filter && filter === "CPF" && (
                <>
                  <InputMask
                    value={valueFilter}
                    onChange={(event): void => {
                      if (event.target.value) {
                        setValueFilter(event.target.value);
                      }
                    }}
                    mask="999.999.999-99"
                    disabled={filter === undefined}
                  >
                    {() => (
                      <TextField
                        placeholder="Ex: 000.000.000-00"
                        disabled={filter === undefined}
                        style={{
                          width: !matchesMobile ? "100%" : 235,
                          marginBottom: 15,
                          marginRight: matchesMobile ? 15 : 0,
                        }}
                        variant="outlined"
                      />
                    )}
                  </InputMask>
                </>
              )}
              {(!filter) && (
                <Autocomplete
                  id="controllable-states-demo"
                  options={[{ name: "" }]}
                  getOptionLabel={(filter) => filter.name}
                  style={{
                    width: !matchesMobile ? "100%" : 235,
                    marginBottom: 15,
                    marginRight: matchesMobile ? 15 : 0,
                  }}
                  disabled
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="-------------"
                    />
                  )}
                />
              )}
              <Button
                variant="contained"
                color="secondary"
                size="large"
                className={classes.buttonSearch}
                style={!matchesMobile ? { width: "100%", margin: 0 } : {}}
                onClick={searchUSer}
                startIcon={<Search />}
              >
                BUSCAR
              </Button>
            </Box>
            <Box style={{ overflow: "auto" }}>
              <Table className={classes.table} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell width="25%">NOME</StyledTableCell>
                    <StyledTableCell align="left">CPF</StyledTableCell>
                    <StyledTableCell align="left">DATA/HORA</StyledTableCell>
                    <StyledTableCell align="left">STATUS</StyledTableCell>
                    <StyledTableCell align="left">SENHA</StyledTableCell>
                    <StyledTableCell align="left" colSpan={2}>SERVIÇO</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loadingPrevious && <CircularProgress />}
                  {previousSchedules &&
                    previousSchedules.map((rowsSchedulesPreviou) => (
                      <Fragment key={rowsSchedulesPreviou.ticket}>
                        <StyledTableRow
                          style={{
                            borderBottomStyle: "none",
                          }}
                        >
                          <StyledTableCell component="th" scope="row">
                            {showDetails &&
                              showDetails === rowsSchedulesPreviou.ticket ? (
                              <Button
                                onClick={() => {
                                  setShowDetails(undefined);
                                }}
                              >
                                <ArrowDropDown />
                              </Button>
                            ) : (
                              <Button
                                onClick={() => {
                                  setShowDetails(rowsSchedulesPreviou.ticket);
                                }}
                              >
                                <ArrowRight />
                              </Button>
                            )}

                            {rowsSchedulesPreviou.nome}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {cpfMask(rowsSchedulesPreviou.cpf)}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {`${dateFormat(rowsSchedulesPreviou.data)} ${rowsSchedulesPreviou.hora
                              }`}
                          </StyledTableCell>
                          <StyledTableCell
                            className={classes.status}
                            align="left"
                          >
                            {rowsSchedulesPreviou.status}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {rowsSchedulesPreviou?.senha_formatada}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {rowsSchedulesPreviou.servico.titulo}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {rowsSchedulesPreviou.para_dependente && rowsSchedulesPreviou.dependentes && (<Button
                              variant="contained"
                              size="small"
                              color="primary"
                              className={classes.buttonIcon}
                              onClick={() => {
                                setSchedulesDependentCurrent(rowsSchedulesPreviou);
                                setOpenDependentsDialog(true);
                              }}
                              title="Dependentes"
                            >
                              <People />
                            </Button>)}
                          </StyledTableCell>
                        </StyledTableRow>

                        {showDetails &&
                          showDetails === rowsSchedulesPreviou.ticket && (
                            <StyledTableRow
                              key={rowsSchedulesPreviou.ticket}
                              style={{
                                borderTopStyle: "dotted",
                                borderTopWidth: 1.4,
                              }}
                            >
                              <StyledTableCell>
                                <Typography
                                  className={classes.textTitleDetails}
                                  style={{ paddingLeft: 60 }}
                                >
                                  INICIO DO ATENDIMENTO
                                </Typography>
                                <Typography
                                  className={classes.textValueDetails}
                                  style={{ paddingLeft: 60 }}
                                >
                                  {rowsSchedulesPreviou.status ===
                                    "Não Compareceu"
                                    ? "Não Compareceu"
                                    : `${rowsSchedulesPreviou?.hora_inicio &&
                                    extractDateFormat(
                                      rowsSchedulesPreviou.hora_inicio
                                    )
                                    } às ${rowsSchedulesPreviou.hora_inicio &&
                                    extractHourFormat(
                                      rowsSchedulesPreviou.hora_inicio
                                    )
                                    }`}
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell>
                                <Typography
                                  className={classes.textTitleDetails}
                                >
                                  FIM DO ATENDIMENTO
                                </Typography>
                                <Typography
                                  className={classes.textValueDetails}
                                >
                                  {rowsSchedulesPreviou.status ===
                                    "Não Compareceu"
                                    ? "Não Compareceu"
                                    : `${extractDateFormat(
                                      rowsSchedulesPreviou.updated_at
                                    )} às ${extractHourFormat(
                                      rowsSchedulesPreviou.updated_at
                                    )}`}
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell colSpan={2}>
                                <Typography
                                  className={classes.textTitleDetails}
                                >
                                  OBSERVAÇÕES:
                                </Typography>
                                {rowsSchedulesPreviou?.observacao_diario
                                  .length ? (
                                  rowsSchedulesPreviou?.observacao_diario.map(
                                    (observacao) => (
                                      <Typography
                                        className={classes.textValueDetails}
                                      >
                                        {`(${extractDateFormat(
                                          observacao.updated_at
                                        )} às ${extractHourFormat(
                                          observacao.updated_at
                                        )})  - (${observacao?.user?.first_name} - ${cpfMask(observacao?.user?.username)})  - ${observacao.conteudo} `}
                                      </Typography>
                                    )
                                  )
                                ) : (
                                  <Typography
                                    className={classes.textValueDetails}
                                  >
                                    Sem Observações
                                  </Typography>
                                )}
                              </StyledTableCell>
                              <StyledTableCell>
                                <Typography
                                  className={classes.textTitleDetails}
                                >
                                  PROTOCOLO AGENDAMENTO
                                </Typography>
                                <Typography
                                  className={classes.textValueDetails}
                                >
                                  {rowsSchedulesPreviou?.protocolo || ''}

                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell colSpan={2}>
                                <Typography
                                  className={classes.textTitleDetails}
                                >
                                  PROTOCOLO ATENDIMENTO
                                </Typography>
                                <Typography
                                  className={classes.textValueDetails}
                                >
                                  {rowsSchedulesPreviou?.protocolo_atendimento || 'Sem protocolo de atendimento'}
                                </Typography>
                              </StyledTableCell>
                            </StyledTableRow>
                          )}
                      </Fragment>
                    ))}
                </TableBody>
              </Table>
            </Box>
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
              <Alert onClose={handleCloseSnackbar} severity="error">
                {errorMessage}
              </Alert>
            </Snackbar>
            <PaginationService
              getSearch={agendamentosAnteriores}
              listSearch={{
                count: countPagePreviousAttendance,
                next: nextPagePreviousAttendance,
                previous: previousPagePreviousAttendance,
                current: currentPagePreviousAttendance,
                total_pages: totalPagesPreviousAttendance,
              }}
            />
          </TabPanel>
        </Box>
      </Box>
    </Box>
  );
}
